import React from 'react';

const NormalCell = ({cell: { value: initialValue }}) => {
  return initialValue;
}

export default NormalCell;